var _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgZyniLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    viewBox: "0 0 135.467 57.15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#a",
    id: "e",
    cx: 1175.185,
    cy: 178.583,
    r: 104.9,
    fx: 1175.185,
    fy: 178.583,
    gradientTransform: "scale(1.06557 1)rotate(90 1309.995 -7.08)",
    gradientUnits: "userSpaceOnUse"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#b",
    id: "f",
    cx: 1182.417,
    cy: -51.684,
    r: 111.778,
    fx: 1182.417,
    fy: -51.684,
    gradientTransform: "matrix(0 1 -.93846 0 1382.856 -1317.075)",
    gradientUnits: "userSpaceOnUse"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#c",
    id: "g",
    cx: 1413.289,
    cy: -50.102,
    r: 104.112,
    fx: 1413.289,
    fy: -50.102,
    gradientTransform: "matrix(0 1 -1.10067 0 1372.872 -1317.075)",
    gradientUnits: "userSpaceOnUse"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#d",
    id: "h",
    cx: 1404.769,
    cy: 189.674,
    r: 112.28,
    fx: 1404.769,
    fy: 189.674,
    gradientTransform: "scale(.92082 1)rotate(90 1400.506 83.43)",
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#feec89",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff100",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#45e4fe",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#01d9fb",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#83d863",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#55c32f",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4c91dd",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2c7ad7",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 135.467,
    height: 57.15,
    ry: 26.774,
    style: {
      opacity: 1,
      fill: "#fff",
      stroke: "none",
      strokeWidth: 2.56404,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.452 21.114h-.434v-3.117h-1.074v-.388h2.578v.388h-1.07zm3.108 0-1.133-3.073h-.019q.015.152.024.413.01.255.01.535v2.125h-.4V17.61h.641l1.06 2.872h.02l1.079-2.872h.636v3.505h-.43V18.96q0-.255.011-.505l.024-.408h-.02l-1.146 3.068z",
    "aria-label": "TM",
    style: {
      fontSize: "2.98618px",
      lineHeight: 1.25,
      fontFamily: "Sans",
      InkscapeFontSpecification: "&quot",
      letterSpacing: 0,
      wordSpacing: 0,
      display: "inline",
      fill: "#000",
      fillOpacity: 1,
      strokeWidth: 0.148588
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.91 35.251q.314 0 .543.228a.74.74 0 0 1 .228.54v1.025a.74.74 0 0 1-.228.54.74.74 0 0 1-.542.228H48.61a.74.74 0 0 1-.543-.227.74.74 0 0 1-.228-.54V36.02q0-.398.2-.683t.228-.313l10.59-14.57h-9.962a.74.74 0 0 1-.542-.227.74.74 0 0 1-.228-.54v-1.025q0-.313.228-.54a.74.74 0 0 1 .542-.228h12.73q.314 0 .543.227a.74.74 0 0 1 .228.541v1.024q0 .456-.371.94L51.378 35.25zm8.392 7.285q-.257.683-.827.683h-1.17a.66.66 0 0 1-.486-.2.66.66 0 0 1-.2-.483q0-.114.029-.2l2.74-5.946-5.652-12.492a.6.6 0 0 1-.028-.2q0-.284.2-.483a.66.66 0 0 1 .485-.2h1.17q.57 0 .828.684l4.396 9.674 4.452-9.674q.257-.683.828-.683h1.17q.285 0 .485.199.2.2.2.484 0 .114-.028.199zm24.718-5.492a.74.74 0 0 1-.228.54.74.74 0 0 1-.542.228h-1.056a.74.74 0 0 1-.543-.227.74.74 0 0 1-.228-.54v-7.513q0-2.134-1.056-3.244t-2.94-1.11q-1.855 0-2.94 1.11-1.056 1.11-1.056 3.244v7.512a.74.74 0 0 1-.228.54.74.74 0 0 1-.543.228h-1.056a.74.74 0 0 1-.542-.227.74.74 0 0 1-.228-.54V23.783q0-.313.228-.54a.74.74 0 0 1 .542-.228h1.056q.314 0 .543.227a.74.74 0 0 1 .228.541v.882q.629-.825 1.713-1.366 1.113-.57 2.711-.569 1.799 0 3.197.768a5.3 5.3 0 0 1 2.17 2.22q.798 1.422.798 3.386zM102.042 20a.74.74 0 0 1-.228.541.74.74 0 0 1-.543.228h-1.627a.74.74 0 0 1-.542-.228.74.74 0 0 1-.228-.54v-1.622q0-.315.228-.541a.74.74 0 0 1 .542-.228h1.627q.314 0 .543.228a.74.74 0 0 1 .228.54zm-.285 17.045a.74.74 0 0 1-.229.54.74.74 0 0 1-.542.228H99.93a.74.74 0 0 1-.543-.227.74.74 0 0 1-.228-.54V23.783q0-.313.228-.54a.74.74 0 0 1 .543-.228h1.056q.314 0 .542.227a.74.74 0 0 1 .229.541z",
    "aria-label": "Zynity",
    style: {
      fontSize: "57.5572px",
      lineHeight: 1.25,
      fontFamily: "Rubik",
      InkscapeFontSpecification: "&quot",
      letterSpacing: 0,
      wordSpacing: 0,
      display: "inline",
      fill: "#033966",
      fillOpacity: 1,
      strokeWidth: 0.891641
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.496)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline",
      fill: "#033966",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1120.598-131.356c-.08-50.069 34.58-84.99 84.294-85l138.88-.029c-19.998 13.975-23.09 46.953-23.196 65.8-.166 29.436.236 20.894-.011 40.696-.488 39.122-17.578 82.535-66.454 96.905-24.605 7.234-59.94 7.307-85.406 5.204-23.562-1.945-47.107-12.93-48.357-44.066-.41-10.217.27-67.128.25-79.51",
    style: {
      display: "inline",
      opacity: 1,
      fill: "url(#e)",
      stroke: "none",
      strokeWidth: 0.225862,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    transform: "matrix(.05836 0 0 .05842 -48.24 28.476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1465.726-216.002c50.069-.081 84.99 34.58 85 84.294l.028 138.88c-15.974-19.748-50.702-21.09-69.549-21.197-29.436-.165-20.896.33-40.696-.01-42.872-.739-78.785-19.579-93.155-68.455-7.234-24.604-7.307-59.94-5.204-85.405 1.945-23.562 12.93-47.108 44.066-48.358 10.217-.41 67.128.27 79.51.25z",
    style: {
      display: "inline",
      opacity: 1,
      fill: "url(#f)",
      stroke: "none",
      strokeWidth: 0.225862,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    transform: "matrix(.05836 0 0 .05842 -48.24 28.476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1551.068 131.943c.081 50.068-34.58 85.002-84.294 85l-144.51-.01c19.999-13.975 25.602-45.563 25.708-64.41.166-29.436-.236-20.894.01-40.695.489-39.122 20.26-79.18 69.074-93.76 31.322-9.355 59.38-10.569 84.845-8.466 23.562 1.945 48.168 11.692 49.418 42.828.41 10.218-.27 67.128-.25 79.511z",
    style: {
      display: "inline",
      opacity: 1,
      fill: "url(#g)",
      stroke: "none",
      strokeWidth: 0.225862,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    transform: "matrix(.05836 0 0 .05842 -48.24 28.476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.245 131.264c-.027-46.293-.029-138.88-.029-138.88 13.975 19.998 44.953 21.59 63.8 21.696 29.436.166 22.845-1.312 42.446 1.511 36.372 5.238 76.162 18.34 93.89 66.1 9.003 24.252 7.036 60.294 4.58 85.406-2.301 23.53-13.965 49.837-45.126 49.837-24.36 0-44.685.014-77.39.01-47.137-.01-82.144-41.05-82.17-85.678z",
    style: {
      display: "inline",
      opacity: 1,
      fill: "url(#h)",
      stroke: "none",
      strokeWidth: 0.225862,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    transform: "matrix(.05836 0 0 .05842 -48.24 28.476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1337.934-63.733c6.568 22.217 13.943 38.23 19.296 44.434S1382.111-6.62 1401.45.155c3.463 1.213 3.547 4.805 0 5.902-18.904 5.844-38.262 14.257-44.22 19.39s-13.458 25.102-19.36 44.434c-1.047 3.43-5.02 3.221-5.873 0-5-18.892-13.794-38.756-19.296-44.434-5.503-5.678-23.189-13.7-44.104-19.454-2.803-.77-2.906-4.914 0-5.902 19.63-6.676 37.278-12.457 44.104-19.39 6.825-6.933 12.18-22.217 19.36-44.434 1.149-3.557 4.843-3.482 5.873 0",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#005cab",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.14005,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    transform: "matrix(.05836 0 0 .05842 -48.24 28.476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2745.674-27.353c4.474 15.084 9.498 25.956 13.144 30.168s16.949 8.608 30.122 13.208c2.36.824 2.416 3.263 0 4.007-12.877 3.968-26.064 9.68-30.122 13.165s-9.167 17.042-13.187 30.168c-.713 2.33-3.42 2.187-4.001 0-3.406-12.826-9.396-26.313-13.145-30.168s-15.795-9.301-30.043-13.208c-1.909-.523-1.979-3.336 0-4.007 13.372-4.533 25.394-8.458 30.043-13.165s8.297-15.084 13.188-30.168c.783-2.415 3.3-2.364 4 0",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#3e8cd1",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.775304,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    transform: "matrix(.05836 0 0 .05842 -48.24 28.476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2842.476 45.911c5.146 17.347 10.923 29.85 15.116 34.693 4.194 4.844 19.491 9.9 34.64 15.19 2.713.947 2.779 3.751 0 4.608-14.808 4.563-29.973 11.131-34.64 15.14-4.667 4.007-10.542 19.598-15.165 34.692-.82 2.679-3.934 2.515-4.602 0-3.916-14.75-10.805-30.26-15.116-34.693-4.31-4.433-18.164-10.696-34.55-15.189-2.194-.602-2.275-3.837 0-4.608 15.378-5.213 29.204-9.726 34.55-15.14 5.347-5.413 9.542-17.346 15.166-34.693.9-2.777 3.795-2.719 4.601 0",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#3e8cd1",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.891599,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    transform: "matrix(.05836 0 0 .05842 -48.24 28.476)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 125.629,
    height: 47.456,
    x: 4.919,
    y: 5.342,
    ry: 22.437,
    style: {
      opacity: 1,
      fill: "none",
      stroke: "#033966",
      strokeWidth: 2.65388,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgZyniLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/zyni_logo.b404812abf9150e1e71c68075e9d1fdb.svg";